import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../hooks';

import { Irp5Actions } from '../actions/irp5/irp5.actions';

import type { Irp5 } from '../interfaces/employee/irp5.interface';

import HrDocumentLocker from './HrDocumentLocker';

// IRP5 tax certificates — same shape as payslips, so same locker.
const Irp5sListV3 = () => {
  const dispatch = useAppDispatch();
  const irp5s: Irp5[] = useAppSelector(({ irp5_store }) => irp5_store.irp5s) || [];
  const [loaded, setLoaded] = useState(irp5s.length > 0);

  useEffect(() => {
    dispatch(Irp5Actions.loadIrp5s(() => setLoaded(true)));
  }, [dispatch]);

  return (
    <HrDocumentLocker
      title="IRP5s"
      eyebrow="Human Resources"
      noun="IRP5"
      records={irp5s}
      loaded={loaded}
      legacyAddPath="/human-resources/irp5s/add"
      legacyEditPath={(id) => `/human-resources/irp5s/${id}`}
    />
  );
};

export default Irp5sListV3;
